<template>
	<div>
		<section
			class="d-flex align-flex-start space-evenly pb-3 pt-4 px-5"
			:style="`border-bottom:0.1rem solid ${globalColors.primary}`"
		>
			<addressData/>
			<billingData/>
		</section>
		<section class="d-flex wrap">
			<div class="flex-65">
				<ordered-products/>
				<payment-method/>
			</div>
			<div class="flex-15">
				<purchase-summary/>
			</div>
		</section>
		<app-footer/>
	</div>
</template>
<script>

export default {
	name: 'Payment',
	components: {
		addressData: () => import('@/components/summary/addressData'),
		appFooter: () => import('@/sections/Footer'),
		billingData: () => import('@/components/summary/billingData'),
		paymentMethod: () => import('@/components/buy/paymentMethods'),
		purchaseSummary: () => import('@/components/purchaseSummary'),
		orderedProducts: () => import('@/components/buy/orderedProducts'),
	},
};
</script>



// WEBPACK FOOTER //
// Payment.vue?1c2cbc76